import { Component } from '@angular/core';

@Component({
  selector: 'app-privacypolicy',
  templateUrl: './privacypolicy.component.html',
  styleUrls: ['./privacypolicy.component.scss']
})
export class PrivacypolicyComponent {
appName = 'ClariChat.ai';
  websiteUrl = 'https://clarichat.ai';
  contactEmail = 'alisuperprofessionalemail@gmail.com';

  effectiveDate = new Date('2026-01-08');
}